import React from "react";
import { ZoomControl } from "@shared/common/components/ZoomControl";
import { ButtonGroup } from "@shared/EDS/components/ButtonGroup";
import { useZoomableCanvas } from "../contexts/ZoomableCanvas/useZoomableCanvas";

interface TopMenuProps {
  readonly zoomToFit: () => void;
  readonly openSidePanel: () => void;
}

export function TopMenu({ zoomToFit, openSidePanel }: TopMenuProps): React.JSX.Element {
  const scale = useZoomableCanvas((s) => s.scale);
  const setZoomLevel = useZoomableCanvas((s) => s.setZoomLevel);

  return (
    <div className="flex w-full items-center justify-end gap-m px-m pt-m pb-0">
      <ZoomControl value={scale} zoomToFit={zoomToFit} setZoomLevel={setZoomLevel} />
      <ButtonGroup>
        <tractie-button
          data-testid="epd-top-menu-open-options-button"
          level="tertiary"
          icon-only
          onClick={openSidePanel}
        >
          <tractie-icon name="filter" />
          Toon opties
        </tractie-button>
      </ButtonGroup>
    </div>
  );
}
